'use client';

import { t } from 'mobx-state-tree';

import { PropertyType } from '../propertyType';

import { PropertyBase } from './propertyBase';

export enum ErrorPropertyType {
  Unknown = 'unknown',
  NullValue = 'null_value',
  InvalidType = 'invalid_type',
  MissingMetadata = 'missing_metadata',
}

/** Model for error/invalid property - displays when property type cannot be resolved */
export const ErrorProperty = t.compose('ErrorProperty', PropertyBase,
  t.model({
    type: t.literal(PropertyType.Error),
    errorType: t.optional(t.enumeration('ErrorPropertyType', Object.values(ErrorPropertyType)), ErrorPropertyType.Unknown),
    errorMessage: t.optional(t.string, 'This property type is not supported'),
    valueType: t.maybe(t.string),
    rawValue: t.maybe(t.string),
  })
).actions(self => ({
  setErrorType(errorType: ErrorPropertyType) {
    self.errorType = errorType;
  },
  setErrorMessage(message: string) {
    self.errorMessage = message;
  },
  setValueType(valueType: string) {
    self.valueType = valueType;
  },
  setRawValue(rawValue: string) {
    self.rawValue = rawValue;
  }
}));
